/**
 * Period totals shown above each detailed report.
 */
import { Box } from '@mui/material';
import {
  CheckCircle as CompletedIcon,
  Cancel as CancelledIcon,
  ShoppingCart as OrdersIcon,
  Payments as MoneyIcon,
  HourglassTop as OpenIcon,
  PersonOff as UnassignedIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StatsCard } from '../common';
import type { ReportSummary } from '../../store/api/detailedReportsApi';
import { formatCurrency, formatNumber } from '../../utils/format';
import { palette } from '../../theme/palette';

const ReportSummaryCards = ({ summary, showUnassigned }: { summary?: ReportSummary; showUnassigned?: boolean }) => {
  const { t } = useTranslation();
  if (!summary) return null;

  return (
    <Box
      sx={{
        display: 'grid',
        // 3 per row keeps money values readable; 5-6 in one row only on very wide screens
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', xl: `repeat(${showUnassigned ? 6 : 5}, 1fr)` },
        gap: 2,
        mb: 3,
      }}
    >
      <StatsCard title={t('reports.detailed.summary.totalOrders')} value={formatNumber(summary.total_orders)} icon={<OrdersIcon />} color={palette.brand[500]} />
      <StatsCard title={t('reports.detailed.summary.completed')} value={formatNumber(summary.completed_orders)} icon={<CompletedIcon />} color={palette.status.success} />
      <StatsCard title={t('reports.detailed.summary.cancelled')} value={formatNumber(summary.cancelled_orders)} icon={<CancelledIcon />} color={palette.status.danger} />
      <StatsCard title={t('reports.detailed.summary.completedValue')} value={formatCurrency(summary.completed_value)} icon={<MoneyIcon />} color={palette.status.success} />
      <StatsCard title={t('reports.detailed.summary.openValue')} value={formatCurrency(summary.open_value)} icon={<OpenIcon />} color={palette.status.warning} />
      {showUnassigned && (
        <StatsCard title={t('reports.detailed.summary.unassigned')} value={formatNumber(summary.unassigned_orders)} icon={<UnassignedIcon />} color={palette.status.info} />
      )}
    </Box>
  );
};

export default ReportSummaryCards;
